exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2I50O{background-color:#f40000;cursor:pointer;margin-left:10px!important}._3VmVw{text-align:center}._21i62{color:#333;background-color:#fff;border-color:#ccc;cursor:pointer;margin-right:10px!important}._2b76v{margin:0 auto}._17mpc{font-family:Roboto,sans-serif;padding:25px 0}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_2I50O",
	"modalContent": "_3VmVw",
	"boton_blanco": "_21i62",
	"modalFooter": "_2b76v",
	"modalBody": "_17mpc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalTurnoElegidoYaFueSeleccionado/ModalTurnoElegidoYaFueSeleccionado.css
// module id = 1204
// module chunks = 0 1 2